import { useEffect, useState } from "react";
import { Megaphone } from "lucide-react";
import { api } from "../../lib/api";
import PageHeader from "../../components/PageHeader";

export default function Comunicados() {
    const [items, setItems] = useState([]);
    useEffect(() => {
        api.get("/communications").then((r) => setItems(r.data || []));
    }, []);

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="comunicados-page">
            <PageHeader
                title="Comunicados"
                subtitle="Anuncios oficiales del colegio."
                right={<Megaphone className="text-edu-gold" />}
            />
            <div className="space-y-4">
                {items.length === 0 && <p className="text-edu-muted">No hay comunicados.</p>}
                {items.map((c) => (
                    <article
                        key={c.id}
                        className="edu-card p-6"
                        data-testid={`communication-${c.id}`}
                    >
                        <div className="flex items-center justify-between mb-2">
                            <h3 className="text-lg font-semibold">{c.title}</h3>
                            <span className="text-xs text-edu-muted">
                                {(c.created_at || "").slice(0, 10)}
                            </span>
                        </div>
                        <p className="text-sm text-edu-body whitespace-pre-line">{c.message}</p>
                        <p className="text-xs text-edu-muted mt-3">— {c.sender_name}</p>
                    </article>
                ))}
            </div>
        </div>
    );
}
